/* =========================================================================
   PAR NO CARRINHO — as peças de um conjunto entram e saem juntas.

   O PROBLEMA
   Toda oferta de conjunto da loja é "compre esta peça e leve a outra". O
   desconto só existe com as duas no carrinho, e a Shopify não amarra qual vai
   com qual: ela zera o item mais caro que estiver elegível. Solta, a cliente
   pode tirar a peça paga e ficar com a de graça, ou juntar peças de ofertas
   diferentes e levar o brinde errado.

   O QUE ISTO FAZ
   As páginas de conjunto marcam as linhas com `_par` (mesma etiqueta) e
   `_par_pecas` (quantas linhas o par tem). Aqui:

   - falta alguma linha do par  -> tira as que sobraram
   - as quantidades divergiram  -> iguala todas

   POR QUE NO CARRINHO E NÃO NO DESCONTO
   Seria melhor no desconto, mas a Shopify não tem como amarrar par em desconto
   nativo — só com discount function, que é app próprio. O carrinho é nosso e
   resolve o caso real: a cliente mexendo no carrinho.

   HONESTAMENTE, NÃO É BLINDAGEM. Quem souber chamar /cart/change na mão ainda
   monta um carrinho torto. Para a cliente de verdade, fecha.

   POR QUE OUVIR O CARRINHO E NÃO O CLIQUE
   O botão de remover, o seletor de quantidade e a gaveta são redesenhados pela
   Section Rendering API a cada mudança. Listener em botão morre no primeiro
   redesenho. Escutando a resposta do próprio /cart, funciona venha a mudança de
   onde vier — gaveta, página do carrinho ou outro script.
   ========================================================================= */

(function () {
  if (window.__tpParCarrinho) return;
  window.__tpParCarrinho = true;

  var ROTAS = /\/cart\/(add|change|update|clear)(\.js)?/;
  var trabalhando = false;

  function prop(item, nome) {
    var p = item && item.properties;
    if (!p) return null;
    return p[nome] != null ? String(p[nome]) : null;
  }

  /* Agrupa as linhas por etiqueta. Linha sem `_par` não participa de nada —
     é o caso do presente e de qualquer item avulso. */
  function grupos(itens) {
    var g = {};
    (itens || []).forEach(function (it, i) {
      var etq = prop(it, '_par');
      if (!etq) return;
      (g[etq] = g[etq] || []).push({ item: it, linha: i + 1 });
    });
    return g;
  }

  function atualizar(mudancas) {
    /* Uma chamada por mudança, em série: o /cart/change devolve o carrinho
       inteiro e reindexa as linhas, então disparar em paralelo faria a segunda
       chamada mexer na linha errada. Por isso vou por `id` (a chave da linha),
       que não muda, em vez de índice. */
    return mudancas.reduce(function (p, m) {
      return p.then(function () {
        return fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: m.chave, quantity: m.quantidade })
        });
      });
    }, Promise.resolve());
  }

  function conferir(carrinho) {
    if (trabalhando || !carrinho || !carrinho.items) return;

    var g = grupos(carrinho.items);
    var mudancas = [];

    Object.keys(g).forEach(function (etq) {
      var linhas = g[etq];
      var esperado = parseInt(prop(linhas[0].item, '_par_pecas') || '0', 10);

      /* Par incompleto: a cliente tirou uma peça. As outras saem junto — foi
         o conjunto que ela desfez, não uma peça isolada. */
      if (esperado > 1 && linhas.length < esperado) {
        linhas.forEach(function (l) {
          mudancas.push({ chave: l.item.key, quantidade: 0 });
        });
        return;
      }

      /* Quantidades diferentes dentro do par: alguém mexeu no seletor de uma
         peça só. Igualo pela MAIOR — subir de 1 para 2 é pedir dois conjuntos,
         e nivelar por baixo desfaria o que a cliente acabou de pedir. Para
         diminuir, ela usa o mesmo seletor e a maior passa a ser a menor. */
      var qtds = linhas.map(function (l) { return l.item.quantity; });
      var maior = Math.max.apply(null, qtds);
      if (Math.min.apply(null, qtds) !== maior) {
        linhas.forEach(function (l) {
          if (l.item.quantity !== maior) {
            mudancas.push({ chave: l.item.key, quantidade: maior });
          }
        });
      }
    });

    if (!mudancas.length) return;

    trabalhando = true;
    atualizar(mudancas)
      .then(function () {
        /* Redesenha o que estiver na tela. `renderContents` é o caminho que a
           própria gaveta do Dawn usa; sem isto o carrinho mostraria por alguns
           segundos um estado que já não existe no servidor. */
        var gaveta = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var secoes = gaveta && typeof gaveta.getSectionsToRender === 'function'
          ? gaveta.getSectionsToRender().map(function (s) { return s.id; })
          : [];
        var url = '/cart.js';
        if (secoes.length) {
          url = '/cart.js?sections=' + encodeURIComponent(secoes.join(',')) +
            '&sections_url=' + encodeURIComponent(window.location.pathname);
        }
        return fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (gaveta && c.sections && typeof gaveta.renderContents === 'function') {
              gaveta.renderContents(c);
            } else {
              window.location.reload();
            }
          });
      })
      .catch(function (e) { console.error('[tp-par-carrinho]', e); })
      .then(function () { trabalhando = false; });
  }

  /* Escuta a resposta de qualquer chamada ao carrinho. O corpo já é o carrinho
     atualizado, então não preciso de uma ida a mais ao servidor no caso comum
     (que é o carrinho estar certo e nada acontecer). */
  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    return fetchOriginal.apply(this, args).then(function (resposta) {
      if (!ROTAS.test(url) || trabalhando) return resposta;
      resposta.clone().json().then(function (dados) {
        if (dados && dados.items) conferir(dados);
      }).catch(function () { /* resposta que não é o carrinho: ignora */ });
      return resposta;
    });
  };

  /* Carrinho já torto ao abrir a página — por exemplo, a cliente removeu uma
     peça, fechou o site e voltou depois. */
  document.addEventListener('DOMContentLoaded', function () {
    fetchOriginal('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(conferir)
      .catch(function () {});
  });
})();
